import { LoadingArea } from '@consigli/facade';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureFlag, useFeatureFlag, useFeatureFlagsReady } from '@/feature-flags';

import { ProjectListPage } from './project-list-page';
import { ProjectListRedesignPage } from './project-list-redesign-page';

/**
 * Chooses between the current project list and the redesign.
 *
 * Waits for `useFeatureFlagsReady` rather than reading the flag alone: an unread
 * flag resolves to `false`, so rendering immediately would paint the old page
 * and then swap it once the first fetch lands. Both branches open on a loading
 * state anyway while projects are fetched, so waiting costs nothing visible.
 *
 * When flags are not configured — local development without Unleash — `ready` is
 * always `true` and this resolves to the current page on the first render.
 */
export const ProjectListRoute: FC = () => {
  const { t } = useTranslation();
  const ready = useFeatureFlagsReady();
  const redesigned = useFeatureFlag(FeatureFlag.AppRedesign);

  if (!ready) {
    return (
      <div className="flex justify-center items-center">
        <LoadingArea title={t('project-list.loading-title')} className="mx-auto mt-[25vh]" />
      </div>
    );
  }

  return redesigned ? <ProjectListRedesignPage /> : <ProjectListPage />;
};
